import * as React from 'react';

const PopoverContainer = (props:any) => (
    <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="#7B838C" d="M11 24h42v32H11z" />
            <path d="M17 31.5h28M17 39.5h28M17 47.5h28" stroke="#E8E9EB" strokeWidth="2" strokeLinecap="round" />
            <path d="M13 10v10h28V10H13z" stroke="#D2D5D8" strokeWidth="4" fill="#D2D5D8" />
        </g>
    </svg>
);

export default PopoverContainer;

